export * from './IconWorldStroked';
